module.exports = __webpack_public_path__ + "img/nevo_header.3a955506.svg";